/**
 * 陶器市カレンダーの絞り込み。
 *
 * デザイン元（nokaze_陶器市カレンダー.html）は JS でカードを生成していたが、
 * それだと初期 HTML が空になり Event の JSON-LD も出せない。
 * **カードは Liquid が全件描いてあり、ここは表示/非表示を切り替えるだけ**。
 *
 * 比較に使うのは metaobject の生のキー文字列（kyushu / spring / …）。
 * 表示名ではないので、言語が変わっても一致判定は壊れない
 * （アプリ側が全ロケールへ同値を登録して自動翻訳をガードしている）。
 */
(function () {
  "use strict";

  function init() {
    var root = document.querySelector("[data-pottery-fair]");
    if (!root) return;

    var listEl = root.querySelector("[data-pf-list]");
    var countEl = root.querySelector("[data-pf-count]");
    var emptyEl = root.querySelector("[data-pf-empty]");
    var regionEl = root.querySelector("[data-pf-region]");
    var seasonEl = root.querySelector("[data-pf-season]");
    var queryEl = root.querySelector("[data-pf-query]");
    var resetEl = root.querySelector("[data-pf-reset]");
    if (!listEl) return;

    var items = Array.prototype.slice.call(
      listEl.querySelectorAll("[data-pf-item]"),
    );

    var state = { region: "", season: "", query: "", month: null, year: null };

    function apply() {
      var q = state.query.toLowerCase();
      var visible = 0;

      items.forEach(function (item) {
        var ok = true;

        if (state.region && item.dataset.region !== state.region) ok = false;
        if (ok && state.season && item.dataset.season !== state.season) ok = false;
        if (
          ok &&
          state.month !== null &&
          !(
            Number(item.dataset.month) === state.month &&
            Number(item.dataset.year) === state.year
          )
        ) {
          ok = false;
        }
        // data-search には Liquid が小文字で連結済みの検索対象が入っている
        if (ok && q && (item.dataset.search || "").indexOf(q) < 0) ok = false;

        item.hidden = !ok;
        if (ok) visible++;
      });

      if (countEl) countEl.textContent = String(visible);
      if (emptyEl) emptyEl.hidden = visible !== 0;

      syncActiveStates();
    }

    /** 地図のピン・地域ボタン・カレンダーの月に選択状態を反映する */
    function syncActiveStates() {
      root.querySelectorAll("[data-region]").forEach(function (el) {
        // カード自身も data-region を持つので、操作系だけに限る
        if (el.hasAttribute("data-pf-item")) return;
        var on = el.dataset.region === state.region;
        el.classList.toggle("is-active", on);
        // 見た目だけでなく状態も伝える。トグルなので aria-pressed が適切
        if (el.hasAttribute("aria-pressed")) {
          el.setAttribute("aria-pressed", String(on));
        }
      });

      root.querySelectorAll(".c-pottery-fair__mon").forEach(function (el) {
        var on =
          state.month !== null &&
          Number(el.dataset.month) === state.month &&
          Number(el.dataset.year) === state.year;
        el.classList.toggle("is-active", on);
        // 見出しが実ボタンなので、押下状態はそちらに載せる。
        // 該当 0 件の月は disabled で aria-pressed を持たない
        var btn = el.querySelector("[data-pf-mon-filter]");
        if (btn && btn.hasAttribute("aria-pressed")) {
          btn.setAttribute("aria-pressed", String(on));
        }
      });
    }

    function scrollToList() {
      var target = root.querySelector("#c-pf-list");
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 16;
      // アニメーションを減らす設定の利用者にはスムーススクロールを強制しない
      var reduce =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      window.scrollTo({ top: top, behavior: reduce ? "auto" : "smooth" });
    }

    /** 同じ地域を再度選んだら解除する（トグル） */
    function pickRegion(region) {
      state.region = state.region === region ? "" : region;
      // 地域と月は同時に絞ると 0 件になりやすいので、片方を選んだらもう片方は解除する
      state.month = null;
      state.year = null;
      if (regionEl) regionEl.value = state.region;
      apply();
      scrollToList();
    }

    function pickMonth(el) {
      var month = Number(el.dataset.month);
      var year = Number(el.dataset.year);
      if (state.month === month && state.year === year) {
        state.month = null;
        state.year = null;
      } else {
        state.month = month;
        state.year = year;
        state.region = "";
        if (regionEl) regionEl.value = "";
      }
      apply();
      scrollToList();
    }

    /** Enter / Space でも押せるようにする（role="button" 要素向け） */
    function onActivateKey(handler) {
      return function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        e.preventDefault();
        handler(e);
      };
    }

    // --- 月の全件モーダル ---
    var modal = root.querySelector("[data-pf-mon-modal]");
    var modalTitle = root.querySelector("[data-pf-mon-modal-title]");
    var modalList = root.querySelector("[data-pf-mon-modal-list]");
    var modalOpener = null;
    // 一覧へ移動して閉じる場合は、フォーカスを「ほか○件」へ戻さない
    // （戻すと直後のスクロールでブラウザが月カードへ引き戻してしまう）
    var modalSkipRefocus = false;

    /**
     * 月カードの ul をそのまま複製してモーダルに出す。
     * カード側で伏せていた「6 件目以降」と日程はモーダルの CSS で出る
     * （親クラスが違うだけで、マークアップは 1 箇所しか無い）。
     */
    function openMonthModal(card) {
      // <dialog> 未対応のブラウザでは何もしない。カードのクリックで一覧が
      // その月に絞られるので、全件を見る手段自体は失われない
      if (!modal || typeof modal.showModal !== "function") return;

      var list = card.querySelector("[data-pf-mon-list]");
      modalList.innerHTML = list ? list.innerHTML : "";
      if (modalTitle) modalTitle.textContent = card.dataset.monTitle || "";
      modalOpener = card;

      modal.showModal();
      // <dialog> は背面の inert 化まではするが、背面のスクロールは止めない
      document.documentElement.style.overflow = "hidden";
    }

    function closeMonthModal() {
      if (modal && modal.open) modal.close();
    }

    if (modal) {
      // close は Esc でも発火する。後始末は 1 箇所に寄せる
      modal.addEventListener("close", function () {
        document.documentElement.style.overflow = "";
        if (modalOpener && !modalSkipRefocus) {
          var btn = modalOpener.querySelector("[data-pf-mon-more]");
          if (btn) btn.focus();
        }
        modalOpener = null;
        modalSkipRefocus = false;
      });

      // 背景（::backdrop）のクリックで閉じる。dialog 自身が背景に当たる
      modal.addEventListener("click", function (e) {
        if (e.target === modal) closeMonthModal();
      });

      var closeBtn = root.querySelector("[data-pf-mon-close]");
      if (closeBtn) closeBtn.addEventListener("click", closeMonthModal);

      var gotoBtn = root.querySelector("[data-pf-mon-goto]");
      if (gotoBtn) {
        gotoBtn.addEventListener("click", function () {
          // close ハンドラが modalOpener を消すので、先に控えておく
          var card = modalOpener;
          modalSkipRefocus = true;
          closeMonthModal();
          if (card) pickMonth(card);
        });
      }
    }

    // --- 地図のピンと地域ボタン ---
    root
      .querySelectorAll(".c-pottery-fair__pin, .c-pottery-fair__regbtn")
      .forEach(function (el) {
        var handler = function () {
          pickRegion(el.dataset.region);
        };
        el.addEventListener("click", handler);
        el.addEventListener("keydown", onActivateKey(handler));
      });

    // --- カレンダーの月 ---
    // 見出しが実ボタンなので Enter / Space はブラウザ任せでよい。
    // カード全体のクリックはマウス向けの補助（キーボードは見出しボタンが担う）。
    root.querySelectorAll(".c-pottery-fair__mon").forEach(function (el) {
      var filterBtn = el.querySelector("[data-pf-mon-filter]");
      if (!filterBtn || filterBtn.disabled) return;

      filterBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        pickMonth(el);
      });

      el.addEventListener("click", function (e) {
        // 「ほか○件」の上でのクリックはモーダル側の担当
        if (e.target.closest("[data-pf-mon-more]")) return;
        pickMonth(el);
      });

      var moreBtn = el.querySelector("[data-pf-mon-more]");
      if (moreBtn) {
        moreBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          openMonthModal(el);
        });
      }
    });

    // --- セレクトと検索 ---
    if (regionEl) {
      regionEl.addEventListener("change", function () {
        state.region = regionEl.value;
        state.month = null;
        state.year = null;
        apply();
      });
    }

    if (seasonEl) {
      seasonEl.addEventListener("change", function () {
        state.season = seasonEl.value;
        apply();
      });
    }

    if (queryEl) {
      var timer;
      queryEl.addEventListener("input", function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          state.query = queryEl.value.trim();
          apply();
        }, 160);
      });
    }

    if (resetEl) {
      resetEl.addEventListener("click", function () {
        state = { region: "", season: "", query: "", month: null, year: null };
        if (regionEl) regionEl.value = "";
        if (seasonEl) seasonEl.value = "";
        if (queryEl) queryEl.value = "";
        apply();
      });
    }

    // 初期状態を反映する（件数の表示と、リロード時にセレクトが復元された場合の同期）
    if (regionEl && regionEl.value) state.region = regionEl.value;
    if (seasonEl && seasonEl.value) state.season = seasonEl.value;
    if (queryEl && queryEl.value) state.query = queryEl.value.trim();
    apply();
  }

  init();

  // テーマエディタでセクションを編集すると Shopify が DOM を差し替える。
  // 購読しないと、以降クリックもセレクトも一切反応しなくなる（要リロード）。
  document.addEventListener("shopify:section:load", init);
})();
